import { c as _c } from "react/compiler-runtime";
import { FormSelectDataType, getContactFieldTitle } from '@systemeio/ui';
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const useSmsSubstitutes = () => {
  const $ = _c(17);
  const {
    t
  } = useLocoTranslation();
  const {
    fields: substitutes
  } = useContactFields();
  let t0;
  if ($[0] !== substitutes?.items || $[1] !== t) {
    const contactSubstitutionData = (substitutes?.items ?? []).map(_temp);
    let t1;
    if ($[3] !== t) {
      t1 = t("dashboard.email.contact_affiliate_id");
      $[3] = t;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== t1) {
      t2 = {
        caption: t1,
        id: "{{affiliate_id}}"
      };
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== t) {
      t3 = t("dashboard.email.contact_affiliate_url");
      $[7] = t;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== t3) {
      t4 = {
        caption: t3,
        id: "{{affiliate_dashboard}}"
      };
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== t2 || $[12] !== t4) {
      t5 = [t2, t4];
      $[11] = t2;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    const affiliateSubstitutionData = t5;
    t0 = [...contactSubstitutionData, ...affiliateSubstitutionData];
    $[0] = substitutes?.items;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const substitutionData = t0;
  const isReady = !!substitutes;
  let t1;
  if ($[14] !== isReady || $[15] !== substitutionData) {
    t1 = {
      substitutionData,
      isReady
    };
    $[14] = isReady;
    $[15] = substitutionData;
    $[16] = t1;
  } else {
    t1 = $[16];
  }
  return t1;
};
function _temp(el) {
  return {
    id: `{{${el.slug}}}`,
    caption: getContactFieldTitle(el)
  };
}